import { globalSettingStore } from '~/stores/GlobalSettingStore';
import { api } from '~/stores/providers/Api2';
import { userStore } from '~/stores/UserStore';
import rename from '~/utils/fnUtil/rename';
import { find, mergeAll, omit, pick, pipe, propOr } from 'ramda';

class BootstrapTenant {
  private fetchDefaultTenant = async () => {
    const tenants = await api.tenant.fetchTenantDomains();
    return pipe(find(propOr(false, 'default')), omit(['id']), rename({ tenantId: 'id' }))(tenants);
  };

  private fetchTenant = async () => {
    const response = await Promise.all([this.fetchDefaultTenant(), api.tenant.fetchCurrentTenant()]);
    const tenant = mergeAll(response);
    const tenantSetting = pipe(
      pick(['freeTrialFlag', 'firstExpiredAt', 'secondExpiredAt', 'toBeDeletedAt', 'conversionNoticeFlag'])
    )(tenant);
    return [tenant, tenantSetting];
  };

  initialize = (callback) => {
    this.fetchTenant().then(([tenant, tenantSetting]) => {
      userStore.setDefaultTenant(tenant);
      globalSettingStore.setTenantSetting(tenantSetting);
      callback(tenant, tenantSetting);
    });
  };
}

export default BootstrapTenant;
